module.exports = __webpack_public_path__ + "img/btn1.27d8796.png";